import styled from 'styled-components';

export const Wrapper = styled.main`
  flex-grow: 1;
  padding: 32px;
  max-height: 100vh;
  background: #f0fbff;
  overflow-y: auto;
`;
